import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';

import { NavigationMenuService, ScrollService } from '@fcom/common/services';
import { isNotEmpty, sanitizeWhiteListedPath, unsubscribe } from '@fcom/core/utils';
import { CmsTemplateService } from '@fcom/cms/services';
import { BreadcrumbService } from '@fcom/common/services/breadcrumb/breadcrumb.service';
import { isNavigationEvent } from '@fcom/common/utils';
import { CmsTemplate } from '@fcom/core-api';
import { ConfigService } from '@fcom/core';
import { finShare } from '@fcom/rx';

import { LoyaltyRoutesPath } from '../../interfaces/loyalty.interface';

const NO_CMS_CONTENT_PATHS = [
  `${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.ERROR}`,
  `${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.CAMPAIGN_ENROLL}`,
];

@Component({
  selector: 'fin-loyalty-layout',
  templateUrl: './loyalty-layout.component.html',
  standalone: false,
})
export class LoyaltyLayoutComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  isFooterOpen$: Observable<boolean>;
  path$: ReplaySubject<string> = new ReplaySubject(1);
  enablePageFeedback = false;

  constructor(
    private navigationMenuService: NavigationMenuService,
    private router: Router,
    private scrollService: ScrollService,
    private cmsTemplateService: CmsTemplateService,
    private breadcrumbService: BreadcrumbService,
    private configService: ConfigService,
    @Inject(PLATFORM_ID) private platform: object
  ) {
    this.subscriptions.add(
      this.router.events
        .pipe(
          filter(isNavigationEvent),
          filter(() => isPlatformBrowser(this.platform)),
          map((event: NavigationEnd) => event.url.replace(/\(.*\)/, '')),
          startWith(this.router.routerState.snapshot.url),
          finShare()
        )
        .subscribe((url) => {
          this.scrollService.scrollTop();
          this.path$.next(sanitizeWhiteListedPath(url, this.configService.cfg));
        })
    );
    this.isFooterOpen$ = this.navigationMenuService.isFooterOpen$;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.path$
        .pipe(
          filter((path) => !NO_CMS_CONTENT_PATHS.some((noCmsPath) => path.endsWith(noCmsPath))),
          switchMap((path) => this.cmsTemplateService.load(path)),
          map((a: CmsTemplate) => a?.header?.[0]?.navigationPathList),
          filter(isNotEmpty)
        )
        .subscribe((pathList) => this.breadcrumbService.setBreadcrumbNormal(pathList))
    );

    if (this.configService.cfg.enableQualtricsPageFeedback) {
      this.enablePageFeedback = true;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
